export default "__VITE_ASSET__CQqjY4cQ__"